(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('seller', seller);

    /* @ngInject */
    function seller() {
        var directive = {
            bindToController: true,
            templateUrl: 'seller.tpl',
            controller: sellerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function sellerController () {
    }
})();